exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my-matching-jobs .see-more{padding:0 14px 50px;text-transform:uppercase;text-align:left}.my-matching-jobs .see-more .mobile-only{display:inline-block}.my-matching-jobs .see-more .desktop-only{display:none}@media only screen and (min-device-width:1000px) and (min-width:1000px){.my-matching-jobs .see-more{padding-bottom:40px;text-align:center}.my-matching-jobs .see-more .mobile-only{display:none}.my-matching-jobs .see-more .desktop-only{display:inline-block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/components/myMatchingJobs/myMatchingJobs.styl
// module id = 75
// module chunks = 0 1